import {$api} from "../http/index";

export default class AuthService {
    static async login(nickname, password) {
        return  $api.post('api/user/login', {nickname, password})
    }

    static async registration(nickname, password, firstName, secondName, role) {
        return  $api.post('api/user/registration', {nickname, password, firstName, secondName, role})
    }

    static async addUser(nickname, password, firstName, secondName, role) {
        return  $api.post('api/user/add', {nickname, password, firstName, secondName, role})
    }

    static async logout() {
        return  $api.post('api/user/logout')
    }


}